module.exports = __webpack_public_path__ + "img/device_1017_1_select.e4c77cf3.svg";